(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-remedy-kits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var sliderId = '.cp-remedykits-section .cp-product-wrapper.has-slider';
    var sliderEl = document.querySelector(sliderId);
    if (!sliderEl || typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var $slider = jQuery(sliderEl);

    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 640,  settings: { slidesToShow: 2 } }
      ]
    });

    // Wire custom arrow buttons
    var section = sliderEl.closest('.cp-remedykits-section');
    section.querySelector('.cp-rk-prev').addEventListener('click', function () {
      $slider.slick('slickPrev');
    });
    section.querySelector('.cp-rk-next').addEventListener('click', function () {
      $slider.slick('slickNext');
    });

    // Sync disabled state with slick's boundary
    $slider.on('afterChange', function (e, slick, currentSlide) {
      var prevBtn = section.querySelector('.cp-rk-prev');
      var nextBtn = section.querySelector('.cp-rk-next');
      prevBtn.classList.toggle('disabled', currentSlide === 0);
      nextBtn.classList.toggle('disabled', currentSlide === slick.slideCount - slick.options.slidesToShow);
    });

    // Set initial disabled state
    section.querySelector('.cp-rk-prev').classList.add('disabled');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var initializedSliders = [];

    function initSlider(sliderId) {
      if (initializedSliders.indexOf(sliderId) !== -1) return;
      var el = document.getElementById(sliderId);
      if (!el || !el.classList.contains('has-slider')) return;
      if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

      jQuery(el).slick({
        arrows: true,
        dots: false,
        infinite: false,
        variableWidth: true
      });
      initializedSliders.push(sliderId);
    }

    var firstWrapper = document.querySelector('.cp-productbycoll-wrapper.active');
    if (firstWrapper) {
      initSlider(firstWrapper.getAttribute('data-slider-id'));
    }

    document.querySelectorAll('.cp-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = this.getAttribute('data-target');
        var tabsContainer = this.closest('.cp-collection-tabs');
        var section = this.closest('.cp-bycollection-section');

        // Update active tab
        tabsContainer.querySelectorAll('.cp-tab-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        this.classList.add('active');

        // Update active wrapper
        section.querySelectorAll('.cp-productbycoll-wrapper').forEach(function (w) {
          w.classList.remove('active');
        });
        var target = document.getElementById(targetId);
        if (target) {
          target.classList.add('active');
          initSlider(target.getAttribute('data-slider-id'));
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-our-bestseller-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.is_cp_bestseller_slider_initialized) return;
    const sliders = document.querySelectorAll('#cp-product-slider.has-slider');
    if (!sliders.length) return;
    sliders.forEach(function(slider) {

      const slides = slider.querySelectorAll('.cp-slide');

      if (slides.length > 2 && typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        jQuery(slider).slick({
          arrows: true,
          dots: false,
          infinite: false,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
              },
            },
          ],
        });
      }
    });
    window.is_cp_bestseller_slider_initialized = true;
  });

  } catch(e) { console.error(e); }
})();
})();
